import { useMemo } from 'react';
import { useTranslations } from 'next-intl';

export function useGlobalCommandMenuCopy() {
  const t = useTranslations('CommandMenu');
  return useMemo(
    () => ({
      products: t('products'),
      threads: t('threads'),
      searchProducts: t('searchProducts'),
      searchThreads: t('searchThreads'),
      runCommand: t('runCommand'),
      searchAll: t('searchAll'),
      noResultsFound: t('noResultsFound'),
      searching: t('searching'),
      productsPrefix: t('productsPrefix'),
      threadsPrefix: t('threadsPrefix'),
      commandsPrefix: t('commandsPrefix'),
      backToAll: t('backToAll'),
      browse: t('browse'),
      recentProducts: t('recentProducts'),
      recentThreads: t('recentThreads'),
      goTo: t('goTo'),
      home: t('home'),
      library: t('library'),
      avatars: t('avatars'),
      commands: t('commands'),
      quickActions: t('quickActions'),
      organizations: t('organizations'),
      lightMode: t('lightMode'),
      darkMode: t('darkMode'),
      createProduct: t('createProduct'),
      newThread: t('newThread'),
      usage: t('usage'),
      trash: t('trash'),
      profileSettings: t('profileSettings'),
      navigate: t('navigate'),
      select: t('select'),
      pageActions: t('pageActions'),
      recent: t('recent'),
      projects: t('projects'),
      aesthetics: t('aesthetics'),
      members: t('members'),
      scheduled: t('scheduled'),
      searchScheduled: t('searchScheduled'),
      searchIn: (scope: string) => t('searchIn', { scope }),
      settings: t('settings'),
      typeToSearch: t('typeToSearch'),
    }),
    [t]
  );
}

export type GlobalCommandMenuCopy = ReturnType<typeof useGlobalCommandMenuCopy>;
